import React from 'react';

import styles from './button.scss';

const Button = ({ children, onClick, className, active }) =>
  <a href="#" onClick={onClick} className={`btn ${className || ''} ${active && 'active'}`}>{children}</a>

export default Button;



// WEBPACK FOOTER //
// ./src/components/layout/Button.js